/**
 * Tokens aligned with /design/design-system.json (light, Linear/Notion-like).
 * Charts and canvas may use fixed colors internally; UI chrome uses these.
 */
export const THEME = {
  bg: "#fafafa",
  bgCard: "#ffffff",
  bgCardHover: "#f4f4f5",
  bgPanel: "#f4f4f5",
  border: "#e4e4e7",
  borderActive: "#0d9488",
  text: "#18181b",
  textMuted: "#52525b",
  textDim: "#71717a",
  accent: "#0d9488",
  accentGlow: "rgba(13, 148, 136, 0.12)",
  danger: "#dc2626",
  dangerGlow: "rgba(220, 38, 38, 0.1)",
  warning: "#ca8a04",
  warningGlow: "rgba(202, 138, 4, 0.12)",
  success: "#16a34a",
  successGlow: "rgba(22, 163, 74, 0.12)",
  salmon: "#ea580c",
  eelgrass: "#059669",
  orca: "#4f46e5",
  turtle: "#7c3aed",
  kelp: "#0891b2",
  crab: "#db2777",
};

export default THEME;
